import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  if (user && user.role) return <Navigate to="/admin" replace/>;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) { toast.success("Welcome"); nav("/admin"); }
    else toast.error(r.error || "Login failed");
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A] p-6">
      <form onSubmit={submit} className="bg-white rounded-lg shadow-2xl p-8 w-full max-w-md space-y-4" data-testid="admin-login-form">
        <div className="text-center mb-2">
          <div className="w-14 h-14 mx-auto bg-[#EA580C] rounded-md flex items-center justify-center font-heading font-extrabold text-white text-xl">RX</div>
          <h1 className="font-heading font-extrabold text-2xl mt-3">REXTECH Admin</h1>
          <p className="text-slate-500 text-sm">Sign in to manage the website</p>
        </div>
        <div><Label>Email</Label><Input type="email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="admin-login-email"/></div>
        <div><Label>Password</Label><Input type="password" value={password} onChange={e=>setPassword(e.target.value)} required data-testid="admin-login-password"/></div>
        <Button type="submit" className="btn-orange w-full" disabled={busy} data-testid="admin-login-submit">{busy ? "Signing in..." : "Sign in"}</Button>
      </form>
    </div>
  );
}
